import React from 'react'
import { differenceInDays, formatDistance, format } from 'date-fns'
import { Popup } from 'semantic-ui-react'

const formatDate = date => {
  const diffDays = differenceInDays(date, new Date())
  if (diffDays > 30) {
    return format(date, 'MMM do, y')
  } else {
    return `${formatDistance(date, new Date())} ago`
  }
}

const DateDisplay = ({
  label = '',
  date,
  ...rest
}: {
  label?: string
  date: Date
} & React.ComponentProps<'span'>) => (
  <span {...rest}>
    {label && <span>{label}:</span>}
    <Popup
      content={
        <span>
          {label && `${label}:`} {format(date, 'MMM do, y @ hh:mm a')}
        </span>
      }
      trigger={
        <span
          // @ts-ignore
          css={{
            '&:hover': {
              cursor: 'help',
            },
            borderBottom: '1px dashed gray',
          }}
        >
          {formatDate(date)}
        </span>
      }
    />
  </span>
)

export default DateDisplay
